import { createClient } from "@supabase/supabase-js";
//TODO: remove this comment

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://mmoarwkxyqaxwogjisjs.supabase.co";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "sb_publishable_uxzw_0DrWaG4p0_aP3MyiA_7grtgzzP";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
	auth: {
		persistSession: false
	}
});

export default supabase;
